import { useState } from 'react';

const useDropdownAnimation = (
    open,
    setOpen,
    enterClass,
    exitClass,
) => {
    const [visible, setVisible] = useState(false);
    const [animationClass, setAnimationClass] = useState('');

    const handleOpen = () => {
        setVisible(true);
        setAnimationClass(enterClass);
        setOpen(true);
    };

    const handleClose = () => {
        setAnimationClass(exitClass);
        setTimeout(() => {
            setVisible(false);
            setOpen(false);
        }, 300);
    };

    const handleToggle = () => {
        open ? handleClose() : handleOpen();
    };

    return {
        visible,
        animationClass,
        handleToggle,
        handleClose,
    };
};

export default useDropdownAnimation;
